import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import type { Locale } from '@/lib/i18n/config';
import type { Dictionary } from '@/lib/i18n/dictionaries';
import type { Faq } from '@/lib/supabase/types';
import { localeField } from '@/lib/i18n/helpers';
import { Reveal } from '@/components/site/reveal';

export function FaqsSection({
  locale,
  dict,
  faqs,
  compact = false,
}: {
  locale: Locale;
  dict: Dictionary;
  faqs: Faq[];
  compact?: boolean;
}) {
  if (!faqs.length) return null;
  return (
    <section id="faqs" className="section-pad bg-secondary/50">
      <div
        className={
          compact
            ? 'container-tight max-w-3xl'
            : 'container-tight grid gap-12 md:grid-cols-[0.9fr_1.1fr]'
        }
      >
        {!compact && (
          <Reveal>
            <span className="eyebrow">{dict.faqs.title}</span>
            <h2 className="mt-3 font-serif text-3xl font-bold text-primary md:text-5xl">{dict.faqs.title}</h2>
            <p className="mt-4 text-lg text-muted-foreground">{dict.faqs.subtitle}</p>
          </Reveal>
        )}

        <Accordion type="single" collapsible className="rounded-xl border border-border bg-card">
          {faqs.map((f, i) => (
            <Reveal
              key={f.id}
              delay={i * 70}
              className="border-b border-border last:border-0"
            >
              <AccordionItem value={f.id} className="border-b-0">
                <AccordionTrigger className="px-6 py-5 text-left text-base font-semibold text-primary">
                  {localeField(f, 'question', locale)}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 text-sm leading-relaxed text-muted-foreground">
                  {localeField(f, 'answer', locale)}
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
